module.exports = __webpack_public_path__ + "img/27_6.40c09878.png";